export const productsObjOne = {
  lightBg: false,
  lightText: true,
  lightTopLine: true,
  lightTextDesc: true,
  topLine: 'Main products',
  headline: 'Mont Blanc Cookie',
  // ! This is an error
  description:
    'Nosotros vendemos una galleta rellena de chocolate y crema de maní.',
  buttonLabel: 'Shop Now',
  imgStart: 'start',
  // ! The image doesn't fit the purpose
  img: require('../../images/svg-10.svg'),
  alt: 'Credit Card'
};

export const productsObjTwo = {
  lightBg: true,
  lightText: false,
  lightTopLine: false,
  lightTextDesc: false,
  topLine: 'Customization',
  headline: 'Send the best box of cookies',
  description:
    'We let you custom the color and the style of your box of CookieBites.',
  buttonLabel: 'Learn More',
  imgStart: '',
  img: require('../../images/svg-4.svg'),
  alt: 'Vault'
};

export const productsObjThree = {
  lightBg: false,
  lightText: true,
  lightTopLine: true,
  lightTextDesc: true,
  topLine: 'View Our Products',
  headline: 'Shop through our catalog of products',
  description:
    'We provide worldwide shipping to all countries. If there are any issues, just issue a refund and we will process your request.',
  buttonLabel: 'Shop Now',
  imgStart: 'start',
  img: require('../../images/svg-1.svg'),
  alt: 'Credit Card'
};
